module.exports = __webpack_public_path__ + "static/media/kakadu_hp.010fdd30.webp";